import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'

const SubjectsSection = observer(({ section, subjects, onRemove }) => {
  return (
    <section
      className={classNames('filter-definition', 'bg-tab-subjects', {
        show: section === 'subjects'
      })}
    >
      <h3 className="active">
        Fächer
        <button className="btn btn-link reset-filter" onClick={onRemove}>
          <i className="glyphicon glyphicon-trash" />
        </button>
      </h3>
      <div className="scrollable">
        <div className="form-group subject-filter">
          {window.APP_CONFIG.list_subject.map((subject) => {
            return (
              <div key={`subject-${subject.id}`}>
                <label
                  htmlFor={`filter-subject-${subject.id}`}
                  className="small"
                >
                  <input
                    id={`filter-subject-${subject.id}`}
                    type="checkbox"
                    name="subject"
                    value={subject.id}
                    checked={(subjects || []).indexOf(subject.id) !== -1}
                  />
                  <span>{subject.title}</span>
                </label>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
})

SubjectsSection.propTypes = {
  onRemove: PropTypes.func.isRequired,
  section: PropTypes.string,
  subjects: PropTypes.array
}

SubjectsSection.componentName = 'SubjectsSection'

export { SubjectsSection as default }



// WEBPACK FOOTER //
// ./src/frontend/map/components/SubjectsSection.js